import { render } from "./ghTempController.vue?vue&type=template&id=ffc6bf56&scoped=true"
import script from "./ghTempController.vue?vue&type=script&lang=js"
export * from "./ghTempController.vue?vue&type=script&lang=js"

import "./ghTempController.vue?vue&type=style&index=0&id=ffc6bf56&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc6bf56"]])

export default __exports__